export const site = {
  'name': 'MatteuSan',
  'version': '3.3.0',
  'author': 'MatteuSan',
  'url': 'https://matteusan.com',
  'themeColor': '#ff6a00',
  'twitter': '@MatteuSan'
};
